import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';

const metrics = [
  {
    label: 'Points',
    index: 0,
  },
  {
    label: 'Tries',
    index: 1,
  },
  {
    label: 'Conversions',
    index: 2,
  },
  {
    label: 'Penalties',
    index: 3,
  },
  {
    label: 'Drop Goals',
    index: 4,
  },
];

const styles = require('./TeamRanking-styles.css');

const TeamRanking = ({
  data, activeTeam, setActiveTeam, playerTablePromise,
}) => {
  const metricDropdownRef = useRef();
  const [activeMetric, setActiveMetric] = useState(metrics[0]);
  const [isMetricDropdownOpen, setMetricDropdownOpen] = useState(false);
  const handleTeamClick = useCallback((event) => {
    const { team } = event.currentTarget.dataset;
    setActiveTeam(team === activeTeam ? null : team);
    (async () => {
      const component = await playerTablePromise;
      const qViz = await component.qVizPromise;
      qViz.model.applyPatches([{
        qOp: 'replace',
        qPath: 'qHyperCubeDef/qDimensions/0/qDef/qFieldDefs/0',
        qValue: JSON.stringify(`=If(c_Team = '${team}', c_Person)`),
      }]);
    })();
  });
  const handleMetricClick = useCallback((event) => {
    const { index } = event.currentTarget.dataset;
    setActiveMetric(metrics[index]);
  });
  const handleMetricDropdownClick = useCallback(() => {
    setMetricDropdownOpen(!isMetricDropdownOpen);
  });
  const handleMetricDropdownOutsideClick = (event) => {
    const outsideClick = !metricDropdownRef.current.contains(event.target);
    if (isMetricDropdownOpen && outsideClick) {
      setMetricDropdownOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener('click', handleMetricDropdownOutsideClick);
    return () => {
      window.removeEventListener('click', handleMetricDropdownOutsideClick);
    };
  });
  return (
    <div className={styles.teamRanking}>
      <div className={styles.teamRankingContent}>

        <div className={styles.teamRankingHeader}>
          <div className={styles.teamRankingText}>
            TEAM RANKING
            {!activeTeam && (
              <div className={styles.noActiveTeam}>
                (SELECT A TEAM FOR DETAILS)
              </div>
            )}
          </div>
          <div ref={metricDropdownRef} className={styles.metricDropdown} onClick={handleMetricDropdownClick}>
            <span>SORT BY</span>
            &nbsp;
            <span className={styles.activeMetric}>{activeMetric.label}</span>
            &nbsp;
            <FaChevronDown />
            <div className={classnames(styles.metricDropdownMenu, isMetricDropdownOpen && styles.open)}>
              {metrics.map((metric, index) => (
                <div key={metric.index} data-index={index} onClick={handleMetricClick}>{metric.label}</div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.teamRankingItems}>
          {data && [...data[0].qNodes].sort((a, b) => b.qValues[activeMetric.index].qValue - a.qValues[activeMetric.index].qValue).map((team) => (
            <div
              key={team.qElemNo}
              className={classnames(
                styles.teamRankingItem,
                (activeTeam && activeTeam !== team.qText) && styles.inactive,
                (activeTeam && activeTeam !== team.qText) && styles.active,
              )}
            >
              <button type="button" className={styles.teamRankingButton} data-team={team.qText} onClick={handleTeamClick}>
                <div className={styles.flag}>
                  <img src={`assets/flags/${team.qText}.png`} alt={`Flag of ${team.qText}`} />
                </div>
                <div className={styles.teamRankingName}>{team.qAttrDims.qValues[0].qText}</div>
                <div className={styles.teamRankingValue}>{team.qValues[activeMetric.index].qValue}</div>
              </button>
            </div>
          ))}
          {new Array(10).fill().map((_, index) => <div key={index} className={styles.teamRankingItemFill} />)}
        </div>
      </div>
    </div>
  );
};

TeamRanking.propTypes = {
  data: PropTypes.array,
  activeTeam: PropTypes.string,
  setActiveTeam: PropTypes.func.isRequired,
  playerTablePromise: PropTypes.object,
};
TeamRanking.defaultProps = {
  data: null,
  activeTeam: null,
  playerTablePromise: null,
};

export default TeamRanking;
